// src/app/work-order-numbers/constants/work-order-import-headers.const.ts
export const WORK_ORDER_IMPORT_HEADERS = [
  'WON',
  'Project',
  'DepartmentCode',
  'Description',
  'IsActive',
  'IsOverhead',
] as const;

export type WorkOrderImportHeader = (typeof WORK_ORDER_IMPORT_HEADERS)[number];